import { IUIPluginBaseConfig } from '@do-lib/global-config-2d';
import { IUIUserConfig } from './interface';
import { EN_UI_CONFIG_NAMESPACE } from './ui_config_interface';

export class UIConfigApplier {
  public static getConfig(): IUIUserConfig {
    return this._config;
  }

  public static setConfig(config: IUIUserConfig) {
    this._config = config;
  }

  private static _config: IUIUserConfig = {};

  /**
   * 应用插件配置
   * @param plugins
   * @returns
   */
  public static applyUIConfig(
    plugins: IUIPluginBaseConfig[],
    namespace: EN_UI_CONFIG_NAMESPACE
  ): void {
    const { uiConfigs } = this._config;
    if (!uiConfigs) {
      return;
    }
    const namespaceConfig = uiConfigs[namespace];
    if (!namespaceConfig) {
      return;
    }

    plugins.forEach((plugin) => {
      // 获取插件配置
      const pluginConfig = namespaceConfig[plugin.title];
      if (!pluginConfig) {
        return;
      }

      const { disabled } = pluginConfig;
      if (disabled) {
        plugin.disabled = true;
      }

      if (pluginConfig.hasOwnProperty('hidden')) {
        plugin.hidden = pluginConfig.hidden;
      }
    });
  }
}
